import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { LiveReportList } from '@futrli-sdk/predict';

import { DuplicateReportWizardContainer } from './duplicate-report-wizard-container';


interface DuplicateReportSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  report: LiveReportList;
}

export const DuplicateReportSidebar = ({ isOpen, onClose, report }: DuplicateReportSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="reporting.duplicate_report" defaultMessage="Duplicate report" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <DuplicateReportWizardContainer onClose={onClose} report={report} />
  </Sidebar>
);
